import { render, staticRenderFns } from "./ClinicSignUpRoute.vue?vue&type=template&id=f95755d4"
import script from "./ClinicSignUpRoute.vue?vue&type=script&lang=js"
export * from "./ClinicSignUpRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports